module.exports = __webpack_public_path__ + "static/media/downloadfile.6f2eb67c.svg";